import { useAToast } from '@Atoms';
import heic2any from 'heic2any';
import imageCompression from 'browser-image-compression';

const { notify, TOAST_TYPES } = useAToast();

const TOAST_ERROR = {
  message: 'errors.generics.unknownIssue.message',
  title: 'errors.generics.unknownIssue.title',
  type: TOAST_TYPES.ERROR,
};

export async function processImageFile(
  file: File,
  options: {
    maxSizeMB?: number;
    fallbackName?: string;
  } = {}
) {
  const { maxSizeMB = 1, fallbackName = 'profile.jpg' } = options;

  let fileToProcess = file;

  try {
    const isHeic = file.type === 'image/heic' || file.name.toLowerCase().endsWith('.heic');

    if (isHeic) {
      const convertedBlob = await heic2any({
        blob: file,
        toType: 'image/jpeg',
        quality: 0.9,
      });

      const name = file.name || fallbackName;
      const safeName = name.toLowerCase().endsWith('.jpg')
        ? name
        : name.replace(/\.heic$/i, '.jpg');

      fileToProcess = new File([convertedBlob as BlobPart], safeName, {
        type: 'image/jpeg',
      });
    }

    const compressed = await imageCompression(fileToProcess, {
      maxSizeMB,
      useWebWorker: true,
    });

    const hasExtension = compressed.name.includes('.');
    const safeName = hasExtension ? compressed.name : fallbackName;

    return new File([compressed], safeName, { type: compressed.type });
  } catch (error) {
    notify(TOAST_ERROR);
    throw error;
  }
}
